export enum Icon {
    gift = 'gift',
    phone = 'phone',
    userSingle = 'user-single',
    male = 'male',
    female = 'female',
    arrowRight = 'arrow-right',
    bucket = 'bucket',
    lock = 'lock',
    referral = 'referral',
    shield = 'shield',
    message = 'message',
    mirror = 'mirror',
    key = 'key',
    dollar = 'dollar',
    dollarColored = 'dollar-colored',
    clock = 'clock',
    stop = 'stop',
    alert = 'alert',
    unstar = 'unstar',
    documents = 'documents',
    webcam = 'webcam',
    selfie = 'selfie',
    warning = 'warning',
    swipeUp = 'swipe-up',
    muteOn = 'mute-on',
    muteOff = 'mute-off',
    heartCupid = 'heart-cupid',
    call = 'call',
    callDisabled = 'call-disabled',
    back = 'back',
    link = 'link',
    pornstar = 'pornstar',
    pornstarMale = 'pornstar-male',
    history = 'history',
    stories = 'stories',
    unlock = 'unlock'
}
